import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

/** Papelera de inmuebles quitados (borrado lógico, 30 días) — solo admin. */
export default function Papelera({ onReload }) {
  const [items, setItems] = useState(null);
  const [abierta, setAbierta] = useState(false);
  const cargar = () => api.get("/inmuebles/papelera").then((r) => setItems(r.data.items)).catch(() => setItems([]));
  useEffect(() => { if (abierta) cargar(); }, [abierta]);
  const restaurar = async (it) => { try { await api.post(`/inmuebles/cliente/${it.codigo}/inmueble/restaurar`, null, { params: { clave: it.clave } }); toast.success(`${it.clave} restaurado en ${it.cliente}`); cargar(); onReload?.(); } catch (e) { toast.error(e?.response?.data?.detail || "No se pudo restaurar"); } };
  return <div className="text-xs" data-testid="inm-papelera">
    <button onClick={() => setAbierta(!abierta)} className="underline text-slate-600" data-testid="inm-papelera-abrir">Papelera{items ? ` (${items.length})` : ""}</button>
    {abierta && <div className="mt-1 p-2 rounded bg-slate-50 space-y-1">
      {!items ? <span>cargando…</span> : !items.length ? <span className="text-slate-500">Sin inmuebles quitados en los últimos 30 días.</span>
        : items.map((it) => <div key={`${it.codigo}-${it.clave}`} className="flex flex-wrap items-center gap-2" data-testid={`inm-papelera-item-${it.clave}`}>
          <span><b>{it.cliente}</b> ({it.codigo}) · {it.tipo} {it.numero} · {it.distrito} · {it.superficie_ha ? `${it.superficie_ha} ha` : ""} · quitado {it.eliminado_en?.slice(0, 16).replace("T", " ")} por {it.eliminado_por} · se purga el {it.purga_el}</span>
          <button onClick={() => restaurar(it)} className="rounded px-2 py-0.5 bg-emerald-700 text-white" data-testid={`inm-restaurar-${it.clave}`}>Restaurar</button>
        </div>)}
    </div>}
  </div>;
}
